import { openOverlay } from "overlay"
import ContentSuggestions from "./ContentSuggestions.svelte"

export function showContentSuggestions() {
	openOverlay(ContentSuggestions, {
		classHeading: "no-underline",
	})
}
